import config from "#/config";
import store from "#/stores";
import { nextTick } from "vue";
import { mapState } from "vuex";
import {
  SET_ITEM_SCREENER_ISPLAYING,
  SET_ITEM_DETAIL
} from "@/libvue/apps/catalog/items/actions";

import { GET_SIGNED_URL } from "@/libvue/apps/catalog/screeners/actions";

import { throttle } from "lodash";

export const videojsMixin = {
  data() {
    return {
      config,
      player: null,
      range: [1, 25],
      currentIndex: 0,
      isPlaying: false,
      videoReached005p: null,
      videoReached010p: null,
      videoReached050p: null,
      videoReached090p: null,
      previousSlider: [0, 99999],
      videoOptions: {
        language: this.$i18n.locale,
        autoplay: false,
        controls: true,
        width: 900,
        sources: [],
        poster: "",
        playbackRates: [0.5, 0.75, 1, 1.5, 2],
        userActions: {
          hotkeys: true
        }
      }
    };
  },
  computed: {
    ...mapState({
      item: (state) => state.items.detail.data,
      profile: (state) => state.auth.user
    }),
    activeScreener() {
      return this.item.screeners
        ? this.item.screeners.find((s) => s)
        : this.item.screener;
    },
    segmentIn() {
      if (this.item.is_segmented) {
        return this.item.segment_in;
      } else {
        return this.$route.query.in ? Number(this.$route.query.in) : 0;
      }
    },
    segmentOut() {
      if (this.item.is_segmented) {
        return this.item.segment_out;
      } else {
        return this.$route.query.out ? Number(this.$route.query.out) : null;
      }
    },
    uiComponents() {
      return [
        {
          presets: ["Playback", "Live"],
          area: "BottomBarRightControls",
          replaceComponent: "Settings",
          get: "remove"
        },
        {
          presets: ["Playback", "Live"],
          area: "BottomBarRightControls",
          replaceComponent: "Fullscreen",
          get: "remove"
        },
        {
          presets: ["Playback", "Live"],
          area: "BottomBarLeftControls",
          replaceComponent: "Forward",
          get: "remove"
        },
        {
          presets: ["Playback", "Live"],
          area: "BottomBarLeftControls",
          replaceComponent: "PlaybackControls",
          get: "remove"
        },
        {
          presets: ["Playback", "Live"],
          area: "BottomBarLeftControls",
          replaceComponent: "TimeDisplayPlaybackContainer",
          get: "remove"
        },
        {
          presets: ["Playback", "Live"],
          area: "BottomBarLeftControls",
          replaceComponent: "Rewind",
          get: "remove"
        },
        {
          presets: ["Playback", "Live"],
          area: "BottomBarRightControls",
          replaceComponent: "PictureInPicture",
          get: "remove"
        }
      ];
    }
  },
  methods: {
    analyseStats: throttle(function (e) {
      if (e) {
        const perc = ((e.currentTime / e.duration) * 100).toFixed(3);

        if (perc > 10 && perc < 50 && !this.videoReached010p) {
          // screener reached 10% viewed, send event_type: play
          this.videoReached010p = 0.1;
          const data = {
            screener: this.item.screeners
              ? this.item.screeners.find((s) => s)
              : this.item.screener,
            metadata: {
              percentage_viewed: this.videoReached010p,
              currentTime: e.currentTime,
              duration: e.duration,
              item_uid: this.item.item ? this.item.item.uid : this.item.uid
            }
          };
          store.commit(SET_ITEM_SCREENER_ISPLAYING, data);
        }
      }
    }, 5000),
    onTimeUpdate(e) {
      this.handleSegmentOut(e.target);
      this.handleSliderChange(e.target);
      this.analyseStats(e.target);
    },
    handleSliderChange(e) {
      if (Math.round(e.currentTime) == this.previousSlider[1]) {
        this.setCurrentTime(this.previousSlider[0]);
        this.player.pause();
      }
    },
    handleSegmentOut(e) {
      if (this.segmentOut && Math.round(e.currentTime) == this.segmentOut) {
        this.player.pause();
        this.setCurrentTime(this.segmentOut + 1);
        this.onPlaybackEnded();
      }
    },
    onSliderChange(range) {
      const start = range[0];
      const end = range[1];

      // there is no way to determine which handle was moved
      // so we have to check if the start or end changed
      if (start !== this.range[0]) {
        this.setCurrentTime(start);
      } else if (end !== this.range[1]) {
        this.setCurrentTime(end);
      }

      this.playerPlay();
    },
    onPlaybackStart() {
      this.isPlaying = true;
      if (this.segmentIn !== 0) {
        this.setCurrentTime(this.segmentIn);
      }
      setTimeout(() => {
        this.showRating = true;
      }, 15000);
    },
    onPlaybackPause() {
      this.player.pause();
      this.isPlaying = false;
    },
    onBtnAllyClick(type) {
      if (type == "play") {
        this.player.play();
      } else {
        this.onPlaybackPause();
      }
      document.getElementById("vjs_video_3_html5_api").focus();
    },
    poster(i) {
      return i.image_versions?.large ? i.image_versions?.large : i.image;
    },
    setCurrentTime(sec) {
      this.player.currentTime(sec);
    },
    setCurrentItem({ item, index, play }) {
      this.showRating = false;
      this.$store.commit(SET_ITEM_DETAIL, item);
      this.currentIndex = index ? index : 0;
      this.videoReached010p = null;
      //S'assurer que le screener n'est plus retourné quand expiré
      if (item?.screener) {
        this.initPlayer(this, item).then(() => {
          if (play) {
            this.player.play();
          }
        });
      }
    },
    onPlaybackEnded() {
      const nextIndex = this.currentIndex + 1;

      if (this.segments && nextIndex < this.segments.length) {
        if (localStorage.getItem("autoplay-mode") === "true") {
          //If the next item is published, it will play.
          this.setCurrentItem({
            item: this.segments[nextIndex],
            index: nextIndex,
            play: this.segments[nextIndex].item.status == "published"
          });
        } else {
          this.onPlaybackPause();
        }
      }
    },
    playerPlay() {
      this.player.play();
    },
    onKeyup(e) {
      const loweredKey = e.key.toLowerCase();
      if (loweredKey === "i") {
        const inTime = Math.floor(this.player.currentTime());
        this.range = [inTime, this.range[1]];
        this.onSliderChange(this.range);
      }
      if (loweredKey === "o") {
        const outTime = Math.ceil(this.player.currentTime());
        this.range = [this.range[0], outTime];
        this.onSliderChange(this.range);
      }
    },
    onPlayerReady(e) {
      this.player = e;
      this.currentSegment = this.detail?.data?.segments[0];
    },
    initPlayer(vm, item) {
      return new Promise((resolve, reject) => {
        if (!vm.isExpired(item) && !vm.hasNoScreener(item)) {
          store
            .dispatch(GET_SIGNED_URL, this.activeScreener.uid)
            .then(({ data }) => {
              //Anciennement avec GET_SCREENER on obtenait aussi les captions
              //Maintenant les captions sont intégrés dans m3u8

              vm.player?.poster(
                item.item ? item.item.image || "" : item.image || ""
              );

              const src = {
                src: data.signed_url,
                type: "application/x-mpegURL"
              };

              const itemType = this.item.item
                ? this.item.item.item_type
                : this.item.item_type;

              const type = itemType == "video" ? "vod" : "aod";

              vm.videoOptions.sources = [src];
              vm.videoOptions.screener = {
                title: this.activeScreener.name,
                uid: this.activeScreener.uid,
                duration: this.activeScreener.duration.toString(),
                type
              };

              vm.showRating = false;

              resolve(src);
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    }
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }
};
